import NotificationCount from './notification-count';

export default NotificationCount;
